import LabelSystem from '@labels/systems/ReduxLabelSystem';

import AssetSystem from './AssetSystem';
import FolderSystem from './FolderSystem';
import OverlaySystem from './OverlaySystem';
import PopupSystem from './PopupSystem';
import RotateMobileScreenSystem from './RotateMobileScreenSystem';
import ModalSystem from './ModalSystem';
import WorkspaceSystem from './WorkspaceSystem';

export default {
	labelSystem: LabelSystem,
	popupSystem: PopupSystem,
	assetSystem: AssetSystem,
	overlaySystem: OverlaySystem,
	rotateMobileScreenSystem: RotateMobileScreenSystem,
	folderSystem: FolderSystem,
	modalSystem: ModalSystem,
	workspaceSystem: WorkspaceSystem
};
